import { useState } from 'react';
import { ADMIN_ALLOWED_EMAIL, supabase } from '../lib/supabase';

export function SignIn() {
  const [email, setEmail] = useState(ADMIN_ALLOWED_EMAIL);
  const [status, setStatus] = useState<'idle' | 'sent' | 'error'>('idle');
  const [err, setErr] = useState<string | null>(null);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (email.toLowerCase() !== ADMIN_ALLOWED_EMAIL.toLowerCase()) {
      setErr('That email is not authorized for this admin.');
      setStatus('error');
      return;
    }
    const { error } = await supabase.auth.signInWithOtp({
      email,
      options: { emailRedirectTo: `${location.origin}/auth/callback` },
    });
    if (error) {
      setErr(error.message);
      setStatus('error');
    } else {
      setStatus('sent');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-[420px]">
        {/* Brand mark */}
        <div className="mb-8 text-center">
          <div className="font-heading text-[22px] font-bold tracking-tight leading-none">
            Holden
            <span className="text-gold font-normal mx-[3px]">|</span>
            GR
          </div>
          <div className="mt-2 text-[10px] font-medium uppercase tracking-[0.18em] text-foreground/55">
            Tool Factory · Admin
          </div>
        </div>

        <div className="rounded-lg border border-border bg-card px-8 py-8 shadow-sm">
          <h1 className="font-heading text-[20px] font-semibold tracking-tight m-0 mb-2">
            Sign in
          </h1>
          <p className="text-[13px] text-foreground/60 mb-6">
            We'll send a magic link to your email.
          </p>

          {status === 'sent' ? (
            <div className="rounded-md border border-border bg-secondary/40 px-4 py-4 text-[13px] text-foreground">
              <div className="font-semibold mb-1">Check your email</div>
              <div className="text-foreground/70">
                We sent a sign-in link to <span className="font-mono text-[12px]">{email}</span>.
              </div>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <label
                  htmlFor="email"
                  className="block text-[10px] font-semibold uppercase tracking-[0.18em] text-foreground/55"
                >
                  Email
                </label>
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="w-full rounded-md border border-border bg-background px-3 py-[10px] font-mono text-[13px] text-foreground transition-colors focus:border-gold focus:outline-none focus:ring-2 focus:ring-gold/20"
                />
              </div>
              {err ? <p className="text-[12px] text-destructive">{err}</p> : null}
              <button
                type="submit"
                className="w-full inline-flex items-center justify-center rounded-md bg-gold px-4 py-[11px] font-heading text-[12px] font-semibold tracking-[0.04em] text-background transition-colors duration-150 hover:bg-gold/90"
              >
                Send magic link
              </button>
            </form>
          )}
        </div>

        <div className="mt-6 text-center text-[11px] uppercase tracking-[0.14em] text-foreground/40">
          tools.holdengr.com
        </div>
      </div>
    </div>
  );
}
